import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    quotationHistory
} from 'services/redux/sales/projectOnboarding/action';
import QuotationHistory from './QuotationHistory';

const mapStateToProps = (state) => ({
  allQuotations: state.projectOnboardingReducer.quotationHistory
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        quotationHistory
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(QuotationHistory);
